// extracted by mini-css-extract-plugin
module.exports = {"crowdfundingCard":"crowdfundingCard_crowdfundingCard__3XEna","countdown":"crowdfundingCard_countdown__XvTxu"};